import axios from 'axios';
// Next we make an 'instance' of it
const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API || 'http://api.konyvelo-net.hu',
});

export default instance;
